import React from "react";

export default function Navbar() {

    return (
        <nav>
            <div>
                <a href="#home">Home</a>
                <a href="#about">About</a>
                <a href="#experience">Experience</a>
                <a href="#all-projects">Projects</a>
            </div>
            <div className="contact-dropdown">
                <button className="contact-btn">Contact / Find Me!</button>
                <div className="contact-options">
                    <a href="mailto:michaelj229@gmail.com">Email Me!</a>
                    <a href="https://github.com/mdbj12">GitHub</a>
                    <a href="https://linkedin.com/in/michael-d-jeung">LinkedIn</a>
                    <a href="https://medium.com/@michaelj229">Medium</a>
                </div>
             </div>
        </nav>
    )
}